
    <a id ="{{ activityHtmlId }}-link"
       [textContent]="activityLabel"
       uiSref="work-packages.show.activity"
       [uiParams]="{workPackageId: workPackage.id!, '#': activityHtmlId }">
    </a>
  